import ActionsList from 'front-office/components/release-electoral-card/actions-list';
import { Fragment, useState } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { Anomaly } from 'front-office/view-models/common-certificate-form';
import AnomalieErrorModal from 'shell/components/shared/anomalie-modal';
import PersonSearch from 'shell/components/shared/person-search/index';
import { ReleaseElectoralCardSearchPersonCrumbs } from 'front-office/constants/release-electoral-card-crumbs';
import { useUserProfile } from 'shell/hooks/use-user-profile';

const ElectoralCardSearchPersonPage = (): React.ReactElement => {
  const [errorModalOpen, setErrorModal] = useState<boolean>(false);
  const [anomalieList, setAnomalieList] = useState<Array<Anomaly> | null>(null);

  const { userProfile } = useUserProfile();
  const authorizationNationalSearch = userProfile.datiLogin?.profile?.feature?.anpr;
  const isNationalSearch = authorizationNationalSearch === '2';

  return (
    <Fragment>
      <Breadcrumbs items={ReleaseElectoralCardSearchPersonCrumbs} />
      <PersonSearch
        setAnomalieList={(anomaly) => setAnomalieList(anomaly)}
        setErrorModal={setErrorModal}
        pathname="/sportello/tessera-elettorale/rilascio"
        action={ActionsList}
        addedTitle="- Rilascio tessera elettorale"
        isNationalSearch={isNationalSearch}
      />
      {anomalieList && anomalieList?.length > 0 ? (
        <AnomalieErrorModal
          open={errorModalOpen}
          onClose={() => {
            setErrorModal(false);
          }}
          dataPersons={anomalieList as Array<Anomaly>}
        />
      ) : (
        <></>
      )}
    </Fragment>
  );
};

ElectoralCardSearchPersonPage.displayName = 'Release electoral card search person page component';

export default ElectoralCardSearchPersonPage;
